import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getConfiguration } from "../../services/settings/settigs.service";

export const fetchSettings = createAsyncThunk("settings/fetchSettings", async () => {
  const response = await getConfiguration();
  return response?.data?.data || {};
});

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectSettings = (state) => state.settings.data;
export const selectSettingsLoading = (state) => state.settings.loading;

export default settingsSlice.reducer;
